import React from 'react';
import { Form } from './form';
import { Information } from './information';
import SvgEnvelope from '@clayton-homes/ui-icons/24/envelope';

export const ContactForm = () => {
  return (
    <div className="bg-[#f7f9fb] pt-[30px] mb-10">
      <h2 className="text-center font-bold">Contact Us</h2>
      <div className="mt-[30px] flex flex-col lg:flex-row max-w-standard mx-auto">
        <div className="w-full h-fit max-w-[480px] bg-white shadow-component mx-auto lg:max-w-[575px]">
          <span className="my-4 inline-flex w-full justify-center">
            <SvgEnvelope className="mr-1 h-5 *:fill-hbg-blue" />
            <h5>Send us a message</h5>
          </span>
          <hr className="border-t border-gray-200" />
          <div className="mb-10 mt-6">
            <Form />
          </div>
        </div>
        <Information />
      </div>
    </div>
  );
};
